import { handleActions } from 'redux-actions';
import { HIDE_MESSAGE, SHOW_MESSAGE } from '../constants';
import { fromJS } from 'immutable';

export default handleActions(
    {
        SHOW_MESSAGE: (state, action) => {
            return state.merge({ message: { text: action.payload, show: true } });
        },
        HIDE_MESSAGE: (state, action) => {
            return state.merge({ message: { text: '', show: false } });
        },
    },
    fromJS({ message: { text: '', show: false } })
);
